import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicPageBackground from '../../components/PublicPageBackground';
import MetaTags from '../../components/MetaTags';
import './Landing.css';

const Landing: React.FC = () => {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // Check if this is the first visit to the landing page
    const hasVisitedLanding = sessionStorage.getItem('hasVisitedLanding');

    if (!hasVisitedLanding) {
      // First visit - show animation
      setShouldAnimate(true);
      // Mark that user has visited
      sessionStorage.setItem('hasVisitedLanding', 'true');
    } else {
      // Subsequent visits - no animation
      setShouldAnimate(false);
    }
  }, []);

  return (
    <>
      <MetaTags
        title="Mindcast"
        description="The Playground for Curious Minds"
        canonicalUrl="https://mindcast.app/"
      />
      <PublicPageBackground>
        <div className="hero-section">
          <div className={`hero-content ${shouldAnimate ? 'landing-content-fade-in' : ''}`}>
            <h1 className="hero-title">
              MINDCAST
            </h1>
            <p className="hero-subtitle">
              The playground for curious minds.
            </p>
            <p className="hero-description">
            </p>

            <div className="hero-actions">
              <Link to="/register" className="cta-button primary">
                Join now
              </Link>
              <Link to="/login" className="cta-button secondary">
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </PublicPageBackground>
    </>
  );
};

export default Landing;
